// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GlRl","badges":"styles_badges__ZW7jp"};